import Constants from '@intercom/embercom-composer/lib/constants';

// please see https://github.com/intercom/embercom-composer/wiki/Data-Formats

//TODO: GJ: we can we use `HtmlEscaper` instead?

export default function (char) {
  if (char.length !== 1) {
    throw new Error('htmlEscapeCharacter expects a single character input');
  }
  switch (char) {
    case '&':
      return '&amp;';
    case '"':
      return '&quot;';
    case '<':
      return '&lt;';
    case '>':
      return '&gt;';
    case "'":
      return Constants.DECIMAL_ENCODED_SINGLE_QUOTE;
    case '`':
      return Constants.DECIMAL_ENCODED_BACKTICK;
    case '=':
      return Constants.DECIMAL_ENCODED_EQUALS;
    case Constants.NEW_LINE:
      return '<br>';
    default:
      return char;
  }
}